import { render, staticRenderFns } from "./rootPassword.vue?vue&type=template&id=44ce1cf3&"
import script from "./rootPassword.vue?vue&type=script&lang=js&"
export * from "./rootPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports